import { useQuery } from '@apollo/client'
import { Divider, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useLocation } from 'react-router-dom'
import config from '../../../config'
import { BucketInvitationDocument } from '../../../graphql/generated'
import StyledFormHeader from './StyledFormHeader'
import StyledFormLinkBold from './StyledFormLinkBold'

const AcceptInviteForm = styled('div')({
  paddingTop: '48px',
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'center',
  fontFamily: '"Outfit", Arial, sans-serif'
})

export default function InvitationHeader() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const invitationId = params.get('invitationId')
  const query = useQuery(BucketInvitationDocument, {
    variables: { invitationId: invitationId! },
    skip: !invitationId // Do not execute the query if invitationId is not available
  })
  const bucketTitle = query.data?.bucketInvitation?.bucketTitle

  if (!invitationId) return null

  return (
    <AcceptInviteForm>
      <img
        style={{
          position: isMobile ? undefined : 'absolute',
          top: isMobile ? undefined : '-80px',
          width: '120px',
          marginBottom: isMobile ? '20px' : '40px',
          border: '1px solid #dfdfdf',
          borderRadius: '200px'
        }}
        src={`${config.assets.url}/img/group-bucket/create-bucket.png`}
        alt="Invitation Icon"
      />
      <Typography sx={{ textAlign: 'center' }}>Accept the invitation to join</Typography>
      <StyledFormHeader sx={{ textAlign: 'center' }} style={{ marginTop: '12px', marginBottom: '12px' }}>
        {bucketTitle}
      </StyledFormHeader>
      <Typography sx={{ textAlign: 'center' }}>
        by signing in with an existing login below. If you don&apos;t have an existing login,
        <StyledFormLinkBold data-test="create-account-button" to={`/auth/register${location.search}`} style={{ fontWeight: 'normal' }}>
          {' '}
          create a new one for free
        </StyledFormLinkBold>
        .
      </Typography>
      <Divider sx={{ width: '100%', my: 2 }} />
    </AcceptInviteForm>
  )
}
